export const selectDropdownAgents = (state: RootState) => {
  return state.dropdown.agents || {};
};
